import ScrollTrigger from "@terwanerik/scrolltrigger";

(function ($) {
   $(function () {
      console.log("Header JS loaded");
      // Create a new ScrollTrigger instance with default options
      const trigger = new ScrollTrigger({
         trigger: {
            once: false,
            offset: {
               element: {
                  x: 0,
                  y: 1
               },
               // viewport: {
               //    x: 0,
               //    y: (trigger, frame, direction) => {
               //       return trigger.visible ? 0 : 1;
               //    },
               // },
               toggle: {
                  callback: {
                     in: (i) => {
                        console.log("in ", i);
                     },
                     visible: (i) => {
                        console.log("visible ", i);
                     },
                     out: (trigger) => {
                        console.log("trigger ", i);
                     }
                  }
               }
            },
         },
      });
      // Add all html elements with attribute data-trigger
      trigger.add("[menumode]");
   });
})(jQuery);
